import { Maybe, ActivityFeed } from "api";
import React, { forwardRef } from "react";
import ActivityMessage from "./ActivityMessage";
import PostComponent from "./index";

interface ActivityComponentProps {
    activity: Maybe<ActivityFeed> | undefined;
}

const ActivityComponent = forwardRef<HTMLDivElement, ActivityComponentProps>(({ activity }, ref) => (
    <PostComponent
        postHeaderComponent={<ActivityMessage activity={activity} />}
        post={activity?.post}
        ref={ref}
    />
))

export default ActivityComponent;
